/** Anything with a start and an optionally open end: a crew, a manager's window, a booking. */
export interface DateSpan {
	startDate: string;
	endDate: string | null;
}

/**
 * Whether a span shares at least one day with the board's window.
 *
 * A null end date means the span runs on, so it is treated as later than every date rather than as
 * missing — which is why only the start has to fall on or before the last visible day. Both ends of
 * the window are inclusive, and every date is a stored `YYYY-MM-DD` string, so the comparisons are
 * lexicographic and need no parsing.
 *
 * @param span - The span being tested.
 * @param windowStart - The board's first visible day.
 * @param windowEnd - The board's last visible day.
 * @returns Whether the span reaches the window.
 */
export function spanReachesWindow(span: DateSpan, windowStart: string, windowEnd: string): boolean {
	if (span.startDate > windowEnd) return false;
	if (span.endDate && span.endDate < windowStart) return false;
	return true;
}
